function rank (rankKey, scoreKey) {
  return function (each, idx, array) {
    if (idx > 0 && array[idx - 1][scoreKey] === each[scoreKey]) {
      each[rankKey] = array[idx - 1][rankKey]
    } else {
      each[rankKey] = idx + 1
    }
  }
}

export default rank



// WEBPACK FOOTER //
// ./src/utils/rank.js